import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { NamedWebhooksIntegration } from "types/generated";

const WebhooksTableNameCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<NamedWebhooksIntegration>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./${webhook.id}`}>{webhook.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default WebhooksTableNameCell;
